module.exports = __webpack_public_path__ + "img/arts-council-dark.54005d28.svg";